import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";

import API from '../../tools/API';
import Modal from '../../components/Modal/Modal';
import PollModal from '../../components/Modal/PollModal';
import RemovePoll from "../../components/Modal/RemovePoll";
import { SingleSetting, Poll, singleCathegory } from '../../tools/interfaces';
import EditPollModal from "../../components/Modal/EditPollModal";
import { getDate } from "../../tools/getDate";

import styles from "./Polls.module.scss"


const Polls = () => {
    const { id } = useParams();
    const [polls, setPolls] = useState<Poll[]>([]);
    const [page, setPage] = useState(0);

    const [showModal, setShowModal] = useState<Poll | boolean>(false);
    const [removePollModal, setRemovePollModal] = useState<number | boolean>(false);

    const [category, setCategory] = useState<singleCathegory | null>(null);
    const [settingList, setSettingList] = useState<SingleSetting[] | null>(null);

    const checkIfStarted = (date: string) => {
        if (new Date() > new Date(date)) {
            return true;
        } else {
            return false;
        }
    }

    useEffect(() => {
        API.getSingleCategory(id as string).then((res) => {
            setCategory(res?.data.data);
        })
        API.getListOfSettings(page, 100).then(res => {
            if (res) {
                setSettingList(res.data.data);
            }
        })
    }, [showModal]);

    useEffect(() => {
        API.getListOfPolls(id as string, page).then(res => setPolls(res?.data.data));
    }, [page, showModal, removePollModal]);

    const pollsReversed = polls.reverse();

    return (
        <>
            <section className={styles.main}>
                <div className={styles.topRow}>
                    <button
                        className={styles.button}
                        onClick={(e) => {
                            e.preventDefault();
                            setShowModal(true);
                        }
                        }>
                        <div className={styles.addIcon}></div>
                        Dodaj ankietę
                    </button>
                </div>
                <div className={styles.mainContent}>
                    <div className={styles.titleBox}>
                        <p>{category?.name}</p>
                    </div>
                    <ul className={styles.pollsList}>
                        {pollsReversed && (
                            pollsReversed.map(x => {
                                return (
                                    <li key={x.id} className={styles.listEl}>

                                        <Link to={`/glosowanie/${x.id}`}>
                                            <p className={styles.pollName}>{x.name}</p>
                                        </Link>
                                        <p className={styles.voteDate}>od {getDate(x.votingFrom)}</p>
                                        <p className={styles.voteDate}>do {getDate(x.votingTo)}</p>
                                        <div className={styles.btnBox}>
                                            <Link to={`/glosowanie/${x.id}`}>
                                                <button className={styles.btnEdit}>Więcej</button>
                                            </Link>
                                            <div>
                                                {
                                                    checkIfStarted(x.votingFrom) ?
                                                        <button className={styles.btnEdit} disabled={true}>Edytuj</button> :
                                                        <button
                                                            className={styles.btnEdit}
                                                            disabled={false}
                                                            onClick={
                                                                () => {
                                                                    setShowModal(x);
                                                                }
                                                            }
                                                        >
                                                            Edytuj
                                                        </button>
                                                }
                                                {
                                                    checkIfStarted(x.votingFrom) ?
                                                        <button className={styles.btnEdit} disabled={true}>Usuń</button> :
                                                        <button
                                                            className={styles.btnEdit}
                                                            disabled={false}
                                                            onClick={
                                                                () => {
                                                                    setRemovePollModal(x.id);
                                                                }
                                                            }
                                                        >
                                                            Usuń
                                                        </button>
                                                }
                                            </div>
                                        </div>
                                    </li>
                                )
                            })
                        )}
                    </ul>
                </div>
                {showModal && category && settingList &&
                    (<Modal openModal={setShowModal}>
                        {typeof showModal === "boolean" ?
                            (
                                <PollModal
                                    openModal={setShowModal}
                                    appId={category.appId}
                                    settingList={settingList}
                                />
                            ) : (
                                <EditPollModal
                                    openModal={setShowModal}
                                    appId={category.appId}
                                    settingList={settingList}
                                    editModal={showModal}
                                />
                            )
                        }
                    </Modal>)
                }
                {
                    removePollModal && (
                        <Modal openModal={setRemovePollModal}>
                            <RemovePoll
                                id={removePollModal as number}
                                openModal={setRemovePollModal}
                            />
                        </Modal>
                    )
                }
            </section>
        </>
    )
}

export default Polls